export default __webpack_public_path__ + "static/media/arrow_forward_blue@2x.30e76bad.png";